<template>

  <div>
    <el-row>
      <el-col :span="24">
         <site-workflow :site-id="rowData.id" :site-name="rowData.siteName" />
      </el-col>
    </el-row>

  </div>

</template>


<script>

import SiteWorkflow from '@/components/workflow/site/SiteWorkflow'

export default {

  components: {
    SiteWorkflow
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },
    owner: {
      type: Number,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  data () {
    return {
      telcoId: this.isTelco() ? Number(this.org().id) : this.owner
    }
  }   // data
}

</script>



// WEBPACK FOOTER //
// SiteWorkflow.vue?39b9421a